import React, { useEffect, useState } from 'react'
import Style from './MoreDetailsPage.module.css'
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography, FormLabel,
  Card, Avatar, CardHeader, CardContent, Button, Grid, useTheme, Portal,
  Dialog, DialogContent, IconButton
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import LocationOnIcon from '@mui/icons-material/LocationOn';
import CakeIcon from '@mui/icons-material/Cake';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import WorkIcon from '@mui/icons-material/Work';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import style from './MoreDetailsPage.module.css'
import LanguageIcon from '@mui/icons-material/Language';
import maleImg from '../../assets/male_modern.png';
import femaleImg from '../../assets/female_modern.png';
import { NavLink } from 'react-router-dom'

import {
  addFavouration, fetchUserSpecificData, userProfile,
  getDetailsFavList, checkFavoriteStatus
} from '../../features/auth/authAction';
import { driveImageDownload, getPaidList } from '../../features/cartAction';

import moment from 'moment'
import { useParams } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import { styled } from '@mui/system';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { alertActions } from '../../features/auth/alertSlice';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import slide2 from '../../images/bg-informationPage.jpeg';
import slide3 from '../../images/slide1.webp';
import slide4 from '../../images/slide2.jpg';
import slide5 from '../../images/slide3.jpg';
import { setBankSlip, showImageStore } from "../../features/cartSlice";
import { ClickAwayListener } from '@mui/base/ClickAwayListener';

const MoreDetailsPage = () => {

  const images = [slide2, slide3, slide4, slide5];

  const [currentIndex, setCurrentIndex] = useState(0);


  const navigate = useNavigate();

  const userSpecificDetails = useSelector(state => state.user?.userSpecificData);
  const storedImage = useSelector((state) => state.cartDetails?.showImageStore);
  const profileInfo = useSelector((state) => state.auth?.profileInfo?.user)
  const favList = useSelector((state) => state.user?.userFavDisplay?.data);
  const DetailFavList = useSelector((state) => state.user?.detailsFavList?.data);
  const paidUserList = useSelector((state) => state.cartDetails?.paidUserList);
  const imagePreviewLink = useSelector((state) => state.cartDetails?.dbStoreImage);
  const permission = useSelector(state => state.auth?.permission?.user_permission);

  const [anchor, setAnchor] = useState(null);
  const [open1, setOpen] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isFavoritedByProfileOwner, setIsFavoritedByProfileOwner] = useState(false);
  const { detailId, loggedUId } = useParams();
  const id = parseInt(detailId);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userProfile())
    dispatch(fetchUserSpecificData(detailId))
    dispatch(getDetailsFavList(detailId));
    dispatch(getPaidList(loggedUId))
    dispatch(driveImageDownload(detailId))
    dispatch(showImageStore("clear"));
    dispatch(setBankSlip({ slip_name: '', date: '' }));

    // Check if viewer has been favorited by profile owner
    if (loggedUId && detailId && loggedUId !== detailId) {
      dispatch(checkFavoriteStatus({ profileId: detailId, viewerId: loggedUId }))
        .then((result) => {
          if (result.payload?.isFavorited) {
            setIsFavoritedByProfileOwner(true);
          }
        });
    }
  }, [dispatch, loggedUId, detailId])


  const calculateAge = (birthdayString) => {
    if (!birthdayString) return '—';
    const m = moment(birthdayString, ['YYYY-MM-DD', moment.ISO_8601], true);
    if (!m.isValid()) return '—';
    const years = moment().diff(m, 'years');
    return years < 0 ? 0 : years;
  };

  const showResponseHandle = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
  };

  const open = Boolean(anchor);
  const popUpId = open ? 'simple-popper' : undefined;

  const handleClickAway = () => {
    setAnchor(null);
  };
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };

  const PopupBody = styled('div')(
    ({ theme }) => `
    width: max-content;
    padding: 12px 16px;
    margin: 8px;
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    box-shadow: ${theme.palette.mode === 'dark'
        ? `0px 4px 8px rgb(0 0 0 / 0.7)`
        : `0px 4px 8px rgb(0 0 0 / 0.1)`
      };
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.975rem;
    z-index: 9999999 !important;
  `,
  );
  const handleFav = () => {
    if (paidUserList?.data?.length > 0) {
      if (hasPermission) {
        // 1. Add "Profile Owner favorites Viewer" (Existing logic - allows Viewer to see Profile Owner's images)
        dispatch(addFavouration({
          'favId': loggedUId,
          'favName': profileInfo.name,
          'userId': id
        })).then((result) => {
          if (result.meta.requestStatus === 'fulfilled') {
            setAnchor(null);
            dispatch(getDetailsFavList(detailId));
            // INSTANTLY enable image preview for the viewer
            setIsFavoritedByProfileOwner(true);
          }
        });

        // 2. Add "Viewer favorites Profile Owner" (New logic - allows Profile Owner to see Viewer's images)
        if (userSpecificDetails?.userData?.[0]) {
          const profileOwnerName = userSpecificDetails.userData[0].firstName;
          dispatch(addFavouration({
            'favId': id,
            'favName': profileOwnerName,
            'userId': loggedUId
          }));
        }

      } else {
        setAnchor(null);
        dispatch(
          alertActions.createAlert({
            message: 'Permission denied by Admin',
            type: 'warning',
          })
        );
      }
    }
    else {
      navigate(`/payment/${loggedUId}`);
      dispatch(
        alertActions.createAlert({
          message: 'You have to do the payment !!!',
          type: 'warning',
        })
      );
    }
  }

  const horoscopeValidation = () => {
    const isFavMatch = favList?.some((item) => Number(item.favId) === Number(detailId));
    const isUserMatch = Number(loggedUId) === Number(detailId);
    return isFavMatch || isUserMatch;
  };

  // const responseBtnValidity = () => {
  // if (DetailFavList) {
  //   const DetailFavLists = DetailFavList?.map((values) => values.favId)
  //   return DetailFavLists.includes(Number(detailId))
  // }
  // }
  const hasPermission = Number(permission) === 1;

  const hasResponded = Boolean(
    DetailFavList?.some(item => item.favId === Number(loggedUId))
  );

  const isOwnProfile = Number(detailId) === Number(loggedUId);
  const isPaidUser = paidUserList?.data?.length > 0;

  return (
    <React.Fragment>
      <Box
        className={style.filterSection}
        sx={{
          width: '100%',
          height: '100%',
          backgroundImage: `url(${images[currentIndex]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'background-image 1s ease-in-out',
          borderRadius: '16px',
          pt: '3rem',
          position: 'relative',
          color: '#fff',
          boxShadow: (theme) => theme.palette.mode === 'dark'
            ? 'inset 0 0 0 1000px rgba(0,0,0,0.65)'
            : 'inset 0 0 0 1000px rgba(0,0,0,0.35)',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: (theme) => theme.palette.mode === 'dark'
              ? 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.5) 100%)'
              : 'transparent',
            borderRadius: '16px',
            zIndex: 1,
          },
          '& > *': {
            position: 'relative',
            zIndex: 2,
          }
        }}
      >

        <Box sx={{ zIndex: 2, px: 4 }}>
          {userSpecificDetails !== null ? (
            userSpecificDetails?.userData?.map((values, index) => (
              <Container className={Style.container} style={{ marginTop: '3rem' }} key={index}>
                <div className={Style.card_container}>
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3 }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <CardHeader
                              avatar={
                                <Avatar
                                  sx={{ backgroundColor: 'red', border: '2px solid red' }}
                                  src={values.gender.toLowerCase() === 'female' ? femaleImg : maleImg}
                                  alt="Male Avatar"
                                />
                              }
                              title={
                                <Typography variant="h5" sx={{ fontSize: '20px', color: 'text.primary' }}>
                                  {values.firstName}{" "}
                                  <span style={{ filter: isPaidUser || isOwnProfile ? 'none' : 'blur(5px)' }}>
                                    {values.lastName}
                                  </span>
                                </Typography>
                              }
                              subheader={
                                <Typography sx={{ color: 'text.secondary' }}>
                                  {moment(values.createdAt).format('YYYY/MM/DD')}
                                </Typography>
                              }
                            />
                            <Grid item xs={12}>
                              <Typography variant="body1" component="div" className={style.icon}>
                                <LocationOnIcon sx={{ mr: 1 }} />
                                <span >{values.city}</span>
                              </Typography>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <CakeIcon sx={{ mr: 1 }} />
                                  {values.age}
                                </Typography>
                              </Grid>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <PersonIcon sx={{ mr: 1 }} />
                                  {values.ethnics}
                                </Typography>
                              </Grid>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <LocalLibraryIcon sx={{ mr: 1 }} />
                                  {values.religion}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <WorkIcon sx={{ mr: 1 }} />
                                  {values.profession}
                                </Typography>
                              </Grid>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <SquareFootIcon sx={{ mr: 1 }} />
                                  {values.height}
                                </Typography>
                              </Grid>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <LanguageIcon sx={{ mr: 1 }} />
                                  {values.city}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                {/* kendara thorathuru */}
                <div className={Style.card_container}>
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1, position: 'relative' }}>
                          {!isPaidUser && !isOwnProfile && (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                backdropFilter: 'blur(3px)',
                                borderRadius: 2
                              }}
                            >
                              <Typography variant="h6" sx={{ color: 'text.primary', mb: 2, fontWeight: 'bold', textAlign: 'center' }}>
                                මෙම තොරතුරු බැලීමට ගෙවීම් කරන්න
                              </Typography>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => navigate(`/pricing-page`)}
                                sx={{ fontWeight: 'bold' }}
                              >
                                Pay Now
                              </Button>
                            </Box>
                          )}
                          <Box sx={{ filter: isPaidUser || isOwnProfile ? 'none' : 'blur(6px)', userSelect: isPaidUser || isOwnProfile ? 'auto' : 'none' }}>
                            <Grid container spacing={2} columns={12}>
                              <CardHeader
                                title={
                                  <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: 700, color: 'text.primary' }}>
                                    කේන්දර තොරතුරු
                                  </Typography>
                                }
                              />
                              <Grid container item xs={16} columns={12}>
                                <Grid xs={6}>
                                  <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                    <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                    සම්පූර්ණ නම:   {values.firstName}   {values.lastName}
                                  </Typography>
                                </Grid>
                                <Grid xs={6}>
                                  <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                    <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                    උපන් වේලාව:  {values?.birthTime}
                                  </Typography>
                                </Grid>

                              </Grid>
                              <Grid container item xs={16} columns={12}>
                                <Grid xs={6}>
                                  <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                    <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                    උපන් දිනය:  {moment(values.birthday).format('YYYY/MM/DD')}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container item xs={16} columns={12}>
                                <Grid>
                                  {/* <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                    <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  </Typography> */}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>

                <div className={Style.card_container}>
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <CardHeader
                              title={
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: 700, color: 'text.primary' }}>
                                  පින්තූර
                                </Typography>
                              }
                            />

                            <Grid item xs={12}>
                              <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                <LanguageIcon sx={{ mr: 1 }} />
                                <span>වැඩි විස්තර සහ සහාය සඳහා අප අමතන්න: +9475-7734313 (සඳුදා - ඉරිදා, පෙ.ව. 9:00 - ප.ව. 10:00)</span>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container item xs={16} lg={12} columns={12}>
                            <Grid xs={4} sx={{ mt: 2 }}>
                              <Grid xs={12} sx={{ mt: 2 }}>
                                {/* Check if viewing own profile or if favorited by profile owner */}
                                {isOwnProfile || isFavoritedByProfileOwner ? (
                                  imagePreviewLink && imagePreviewLink.length > 0 ? (
                                    <Grid container spacing={2}>
                                      {imagePreviewLink.map((values) => (
                                        <Grid item xs={6} sm={4} md={3} key={values.id}>
                                          <Box
                                            onClick={() => {
                                              setSelectedImage(`https://drive.google.com/uc?export=view&id=${values.id}`);
                                              setLightboxOpen(true);
                                            }}
                                            sx={{
                                              position: 'relative',
                                              width: '100%',
                                              height: 200,
                                              overflow: 'hidden',
                                              borderRadius: 2,
                                              boxShadow: 2,
                                              cursor: 'pointer',
                                              transition: 'transform 0.3s ease-in-out',
                                              '&:hover': {
                                                transform: 'scale(1.05)',
                                                boxShadow: 5
                                              }
                                            }}
                                          >
                                            <img
                                              src={`https://drive.google.com/thumbnail?id=${values.id}&sz=w1000`}
                                              alt={values.id}
                                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                            <Box
                                              sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%) rotate(-45deg)',
                                                color: 'rgba(255, 255, 255, 0.3)',
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                pointerEvents: 'none',
                                                userSelect: 'none',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                                                zIndex: 1,
                                                whiteSpace: 'nowrap'
                                              }}
                                            >
                                              Yuwathipathi
                                            </Box>
                                          </Box>
                                        </Grid>
                                      ))}
                                    </Grid>
                                  ) : (
                                    <Typography variant="body2" color="text.secondary" align="center">
                                      No images available.
                                    </Typography>
                                  )
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      minHeight: 200,
                                      backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                      borderRadius: 2,
                                      p: 4
                                    }}
                                  >
                                    <Typography variant="h6" sx={{ color: 'text.primary', mb: 2, fontWeight: 'bold', textAlign: 'center' }}>
                                      පින්තූර බැලීමට අවසර නැත
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center', mb: 2 }}>
                                      ඔබ මෙම පින්තූර බැලීමට, පැතිකඩ අයිතිකරු විසින් ඔබව ප්‍රියතමයක් ලෙස සලකුණු කළ යුතුය.
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', fontStyle: 'italic' }}>
                                      (The profile owner must favorite you to view their images)
                                    </Typography>
                                  </Box>
                                )}
                              </Grid>
                            </Grid>
                            <Grid container item xs={16} lg={12} columns={12}>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container}>
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <CardHeader
                              title={
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: 700, color: 'text.primary' }}>
                                  ප්‍රතිචාරය
                                </Typography>
                              }
                            />
                            <Grid item xs={12}>
                              <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary', mb: 2 }}>
                                <LanguageIcon sx={{ mr: 1 }} />
                                <span>මෙම දැන්වීමට ප්‍රතිචාර දක්වන්න සහ සම්බන්ධතා විස්තර ලබා ගන්න.</span>
                              </Typography>
                              <Typography variant="body2" component="div" sx={{ color: 'text.secondary', ml: 4, mb: 1 }}>
                                • ප්‍රතිචාර දැක්වීමට ඔබ ලියාපදිංචි විය යුතු සහ ගෙවීමක් සම්පූර්ණ කළ යුතුය.
                              </Typography>
                              <Typography variant="body2" component="div" sx={{ color: 'text.secondary', ml: 4, mb: 1 }}>
                                • ප්‍රතිචාර දැක්වීමෙන් පසු ඔබට සම්බන්ධතා විස්තර ලබා ගත හැකිය.
                              </Typography>
                              <Typography variant="body2" component="div" sx={{ color: 'text.secondary', ml: 4, mb: 2 }}>
                                • වැඩි විස්තර සඳහා අප අමතන්න: 078-7738966
                              </Typography>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={4}>
                                <Typography variant="body1" component="div" className={style.icon}>
                                  {!isOwnProfile ? (
                                    hasResponded ? (
                                      <Button variant="contained" sx={{ borderRadius: 999 }} disabled>
                                        ප්‍රතිචාර ලබා දී ඇත
                                      </Button>
                                    ) : hasPermission ? (
                                      <Button
                                        variant="contained"
                                        onClick={showResponseHandle}
                                        sx={{
                                          backgroundColor: '#054A49',
                                          color: '#fff',
                                          '&:hover': { backgroundColor: '#043d3c' }
                                        }}
                                      >
                                        ප්‍රතිචාරය දක්වන්න
                                      </Button>
                                    ) : (
                                      <NavLink to={`/payment/${loggedUId}`} style={{ textDecoration: 'none' }}>
                                        <Button
                                          variant="contained"
                                          sx={{
                                            backgroundColor: '#054A49',
                                            color: '#fff',
                                            '&:hover': { backgroundColor: '#043d3c' }
                                          }}
                                        >
                                          ගෙවීම අවශ්‍ය වේ
                                        </Button>
                                      </NavLink>
                                    )
                                  ) : (
                                    /* Favorite List */
                                    <Grid item xs={12} lg={6}>
                                      <FormLabel sx={{ color: 'text.primary', mb: 1, display: 'block' }}>ප්රියතම ලැයිස්තුව</FormLabel>
                                      <List sx={{ width: '90%', maxWidth: 450, maxHeight: 200, overflow: 'auto' }}>
                                        {favList?.length ? (
                                          favList.map(item => (
                                            <ListItem key={item.favId}>
                                              <ListItemText primary={item.favName} />
                                            </ListItem>
                                          ))
                                        ) : (
                                          <ListItem>
                                            <ListItemText primary="No favorites available" />
                                          </ListItem>
                                        )}
                                      </List>
                                    </Grid>
                                  )}

                                </Typography>
                              </Grid>
                            </Grid>

                            {open && (
                              <Portal container={document.body}>
                                <ClickAwayListener onClickAway={handleClickAway}>
                                  <BasePopup
                                    id={id}
                                    open={open}
                                    anchor={anchor}
                                    placement="bottom-end"
                                    disablePortal={false}
                                    style={{ zIndex: 999999 }}  // ✅ Direct style prop
                                  >
                                    <PopupBody>
                                      සම්බන්ධතා විස්තර පෙන්වීමට ඔබ වෙබ් අඩවියට ලියාපදිංචි විය යුතුය.
                                      <br />
                                      විස්තර ලබා ගැනීමට, ඔබට මුලින්ම ගෙවීමක් කරන්න අවශ්‍ය වේ.<br />එම පුද්ගලයාද ඔබට ප්‍රියතමයෙකු ලෙස පිළිගත යුතුය.
                                      <br /><br />
                                      <strong>චැට් පහසුකම:</strong> ඔබ දෙදෙනාම එකිනෙකා ප්‍රියතම ලැයිස්තුවට එකතු කළ විට පමණක් චැට් කිරීමට හැකිය.
                                      <br /><br />
                                      <strong style={{ color: '#ff6b6b' }}>⚠️ රහස්‍යතාව:</strong> කරුණාකර ඔබේ පෞද්ගලික තොරතුරු බෙදා ගැනීමේදී ප්‍රවේශම් වන්න.
                                      <div style={{ display: 'flex', flexDirection: 'row', marginTop: '12px' }}>
                                        <Button
                                          onClick={() => handleFav()}
                                          variant="contained"
                                          sx={{
                                            backgroundColor: '#054A49',
                                            color: '#fff',
                                            '&:hover': { backgroundColor: '#043d3c' }
                                          }}
                                        >
                                          ප්‍රතිචාරය දෙන්න
                                        </Button>
                                      </div>
                                    </PopupBody>
                                  </BasePopup>
                                </ClickAwayListener>
                              </Portal>
                            )}
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container} >
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <CardHeader
                              title={
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: 700, color: 'text.primary' }}>
                                  පෞද්ගලික තොරතුරු
                                </Typography>
                              }
                            />
                            <Grid container item xs={16} columns={12} sx={{ fontWeight: 600, color: 'text.primary' }}>
                              මූලික
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වාර්ගිකත්වය:  {values.ethnics}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  කුලය:  {values.caste}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  ආගම:  {values.religion}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  විවාහික තත්ත්වය:  {values.civilState}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වයස:  {calculateAge(values.birthday)}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  උස:  {values.height} cm
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container} >
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <Grid container item xs={16} columns={12} sx={{ pl: 4, fontWeight: 600, color: 'text.primary' }}>
                              පදිංචිකරු

                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  රට:  {values.country}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  නගරය:   {values.city}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  ප්රාන්තය/ දිස්ත්රික්කය: {values.district}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container} >
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <Grid container item xs={16} columns={12} sx={{ pl: 3, fontWeight: 600, color: 'text.primary' }}>
                              අධ්‍යාපනය සහ වෘත්තිය
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              {/* <Grid xs={6}>
                            <Typography variant="body1" component="div" className={style.icon}>
                              <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                              අධ්යාපන:
                            </Typography>
                          </Grid> */}
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වෘත්තිය:  {values.profession}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container} >
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <Grid container item xs={16} columns={12} sx={{ pl: 3, fontWeight: 600, color: 'text.primary' }}>
                              පුරුදු
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  බීමත්කම:   {values.drinking}

                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  ආහාර මනාපය: {values.foodPreference}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={16} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  දුම්පානය කරනව: {values.smoking}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container} >
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <CardHeader
                              title={
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: 700, color: 'text.primary' }}>
                                  පවුලේ තොරතුරු
                                </Typography>
                              }
                            />
                            <Grid container item xs={12} columns={12} sx={{ pl: 3, fontWeight: 600, color: 'text.primary' }}>
                              පියා
                            </Grid>
                            <Grid container item xs={12} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වාර්ගිකත්වය: {values.fEthnics}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  කුලය: {values.fCaste}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={12} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  ආගම: {values.fReligion}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වෘත්තිය: {values.fProfession}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={12} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  රට: {values.fCountry}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
                <div className={Style.card_container} >
                  <Grid container spacing={1} justifyContent="center">
                    <Card className={Style.card_style} sx={{ bgcolor: 'background.paper', color: 'text.primary' }}>
                      <CardContent>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2} columns={12}>
                            <CardHeader
                              title={
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: 700, color: 'text.primary' }}>
                                  පවුලේ තොරතුරු
                                </Typography>
                              }
                            />
                            <Grid container item xs={12} columns={12} sx={{ pl: 3, fontWeight: 600, color: 'text.primary' }}>
                              මව
                            </Grid>
                            <Grid container item xs={12} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වාර්ගිකත්වය: {values.mEthnics}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  කුලය: {values.mCaste}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={12} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  ආගම: {values.mReligion}
                                </Typography>
                              </Grid>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  වෘත්තිය: {values.mProfession}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container item xs={12} columns={12}>
                              <Grid xs={6}>
                                <Typography variant="body1" component="div" className={style.icon} sx={{ color: 'text.primary' }}>
                                  <FiberManualRecordIcon fontSize="small" sx={{ mr: 1, ml: 2, pl: 1 }} />
                                  රට: {values.mCountry}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </div>
              </Container>
            ))
          ) : (
            <Box sx={{ textAlign: 'center', py: 8, color: 'text.primary' }}>
              <Typography variant="h5">No Details Found</Typography>
            </Box>
          )}



        </Box>
      </Box >

      {/* Image Lightbox Dialog */}
      <Dialog
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: 'transparent',
            boxShadow: 'none',
            overflow: 'hidden',
            m: 0,
            borderRadius: 0
          }
        }}
      >
        <DialogContent sx={{
          p: 0,
          position: 'relative',
          bgcolor: 'rgba(0,0,0,0.95)',
          minHeight: '90vh'
        }}>
          {/* Close Button */}
          <IconButton
            onClick={() => setLightboxOpen(false)}
            sx={{
              position: 'absolute',
              top: 24,
              right: 24,
              color: '#fff',
              bgcolor: 'rgba(0,0,0,0.6)',
              backdropFilter: 'blur(4px)',
              '&:hover': {
                bgcolor: 'rgba(0,0,0,0.8)',
                transform: 'scale(1.1)'
              },
              zIndex: 2,
              transition: 'all 0.2s ease'
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Loading Spinner */}
          {!selectedImage && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '80vh',
              color: '#fff'
            }}>
              <Typography>Loading image...</Typography>
            </Box>
          )}

          {/* Full Image */}
          {selectedImage && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '80vh',
              p: { xs: 2, md: 4 },
              position: 'relative'
            }}>
              <img
                src={selectedImage}
                alt="Full size"
                onLoad={() => console.log('✅ Image loaded successfully')}
                onError={(e) => {
                  console.error('❌ Image failed to load, trying thumbnail fallback');
                  // Extract ID from URL if needed
                  const idMatch = selectedImage.match(/id=([^&]+)/);
                  if (idMatch) {
                    e.target.src = `https://drive.google.com/thumbnail?id=${idMatch[1]}&sz=w2000`;
                  }
                }}
                style={{
                  maxWidth: '95%',
                  maxHeight: '90vh',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: '12px',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                  transform: 'scale(0.98)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(0.98)'}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%) rotate(-45deg)',
                  color: 'rgba(255, 255, 255, 0.2)',
                  fontSize: { xs: '3rem', md: '5rem' },
                  fontWeight: 'bold',
                  pointerEvents: 'none',
                  userSelect: 'none',
                  textShadow: '0px 0px 20px rgba(0,0,0,0.5)',
                  zIndex: 10,
                  whiteSpace: 'nowrap'
                }}
              >
                Yuwathipathi
              </Box>
            </Box>
          )}

          {/* Navigation Arrows (Optional) */}
          {imagePreviewLink && imagePreviewLink.length > 1 && selectedImage && (
            <>
              <IconButton
                onClick={() => {
                  const currentIdx = imagePreviewLink.findIndex(img =>
                    selectedImage.includes(img.id)
                  );
                  const nextIdx = (currentIdx + 1) % imagePreviewLink.length;
                  setSelectedImage(`https://drive.google.com/uc?export=view&id=${imagePreviewLink[nextIdx].id}`);
                }}
                sx={{
                  position: 'absolute',
                  left: 24,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  bgcolor: 'rgba(0,0,0,0.6)',
                  color: '#fff',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' }
                }}
              >
                Previous
              </IconButton>

              <IconButton
                onClick={() => {
                  const currentIdx = imagePreviewLink.findIndex(img =>
                    selectedImage.includes(img.id)
                  );
                  const nextIdx = (currentIdx + 1) % imagePreviewLink.length;
                  setSelectedImage(`https://drive.google.com/uc?export=view&id=${imagePreviewLink[nextIdx].id}`);
                }}
                sx={{
                  position: 'absolute',
                  right: 24,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  bgcolor: 'rgba(0,0,0,0.6)',
                  color: '#fff',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' }
                }}
              >
                Next
              </IconButton>
            </>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment >
  )
}
export default MoreDetailsPage
